import { render, staticRenderFns } from "./ChallengerDetailCommunity.vue?vue&type=template&id=53ca85c4&scoped=true"
import script from "./ChallengerDetailCommunity.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailCommunity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca85c4",
  null
  
)

export default component.exports